import React, { useState } from 'react';
import { Card, Table, Button, Row, Col, Badge, OverlayTrigger, Popover, ButtonGroup } from 'react-bootstrap';
import { useQuery } from 'react-query';
import moment from 'moment';
import { LICHHUONGDANTHUCHANH_API } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';

const StudentScheduleThucHanhTab = ({ lopId }) => {
    // 1. Filter States: Tháng / Năm
    const [thang, setThang] = useState(moment().month() + 1);
    const [nam, setNam] = useState(moment().year());
    const [viewMode, setViewMode] = useState('matrix'); // 'matrix' | 'list'

    // 2. Fetch Ma trận thời khóa biểu cá nhân của Học viên (Backend tự lọc theo Token)
    const {
        data: matrixData,
        isLoading: isMatrixLoading,
        refetch: refetchMatrix
    } = useQuery(
        ['studentMatrixSchedule', lopId, thang, nam],
        () => Get(`${LICHHUONGDANTHUCHANH_API.GET_MATRIX_HOC_VIEN_CA_NHAN}/${lopId}?thang=${thang}&nam=${nam}`),
        {
            enabled: !!lopId && viewMode === 'matrix',
            staleTime: 0,
            cacheTime: 0,
            select: (res) => res?.data || res
        }
    );

    // 3. Fetch Danh sách lịch học chi tiết của Học viên
    const {
        data: listData = [],
        isLoading: isListLoading,
        refetch: refetchList
    } = useQuery(
        ['studentScheduleList', lopId],
        () => Get(`${LICHHUONGDANTHUCHANH_API.GET_LICH_HOC_VIEN_CA_NHAN}/${lopId}`),
        {
            enabled: !!lopId && viewMode === 'list',
            staleTime: 0,
            cacheTime: 0,
            select: (res) => res?.$values || res?.data?.$values || res?.data || res || []
        }
    );

    const handlePrevMonth = () => {
        if (thang === 1) {
            setThang(12);
            setNam(nam - 1);
        } else {
            setThang(thang - 1);
        }
    };

    const handleNextMonth = () => {
        if (thang === 12) {
            setThang(1);
            setNam(nam + 1);
        } else {
            setThang(thang + 1);
        }
    };

    const matrixDates = matrixData?.dates?.$values || matrixData?.dates || [];
    const matrixRows = matrixData?.rows?.$values || matrixData?.rows || [];

    return (
        <div>
            {/* Header Toolbar */}
            <Card className="shadow-sm border-0 mb-3">
                <Card.Body className="py-2">
                    <Row className="align-items-center justify-content-between">
                        <Col md={6} className="d-flex align-items-center flex-wrap">
                            <ButtonGroup className="mr-3 shadow-sm">
                                <Button
                                    variant={viewMode === 'matrix' ? 'primary' : 'outline-primary'}
                                    size="sm"
                                    onClick={() => setViewMode('matrix')}
                                    className="font-weight-bold"
                                >
                                    <i className="fas fa-calendar-alt mr-1"></i> Thời Khóa Biểu Tháng
                                </Button>
                                <Button
                                    variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
                                    size="sm"
                                    onClick={() => setViewMode('list')}
                                    className="font-weight-bold"
                                >
                                    <i className="fas fa-list mr-1"></i> Danh Sách Buổi Học
                                </Button>
                            </ButtonGroup>

                            {viewMode === 'matrix' && (
                                <div className="d-flex align-items-center">
                                    <Button variant="outline-secondary" size="sm" onClick={handlePrevMonth} className="mr-1">
                                        <i className="fas fa-chevron-left"></i>
                                    </Button>
                                    <span className="font-weight-bold mx-2 text-primary">
                                        Tháng {thang}/{nam}
                                    </span>
                                    <Button variant="outline-secondary" size="sm" onClick={handleNextMonth} className="ml-1">
                                        <i className="fas fa-chevron-right"></i>
                                    </Button>
                                </div>
                            )}
                        </Col>

                        <Col md={6} className="d-flex align-items-center justify-content-md-end mt-2 mt-md-0">
                            {viewMode === 'matrix' && (
                                <div className="d-flex align-items-center mr-3 small">
                                    <span className="mr-2">
                                        <span className="badge badge-primary mr-1">■</span> Buổi học
                                    </span>
                                    <span>
                                        <span className="badge badge-danger mr-1">■</span> Nghỉ
                                    </span>
                                </div>
                            )}
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => {
                                    if (viewMode === 'matrix') refetchMatrix();
                                    else refetchList();
                                }}
                            >
                                <i className="fas fa-sync-alt mr-1"></i> Tải lại
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* VIEW 1: MA TRẬN THỜI KHÓA BIỂU THEO THÁNG */}
            {viewMode === 'matrix' && (
                <Card className="shadow-sm border-0">
                    <Card.Body className="p-0">
                        <div className="table-responsive" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <Table bordered hover size="sm" className="mb-0 text-center align-middle" style={{ fontSize: '13px' }}>
                                <thead className="thead-light">
                                    <tr>
                                        <th style={{ width: 45, position: 'sticky', top: 0, left: 0, background: '#f8f9fa', zIndex: 10 }}>#</th>
                                        <th style={{ minWidth: 200, position: 'sticky', top: 0, left: 45, background: '#f8f9fa', zIndex: 10 }} className="text-left">
                                            Lịch đào tạo
                                        </th>
                                        {matrixDates.map((dStr, idx) => {
                                            const dMoment = moment(dStr);
                                            const dayOfWeek = dMoment.format('dd');
                                            const isWeekend = dMoment.day() === 0 || dMoment.day() === 6;
                                            return (
                                                <th
                                                    key={idx}
                                                    style={{
                                                        minWidth: 40,
                                                        position: 'sticky',
                                                        top: 0,
                                                        background: isWeekend ? '#fff3cd' : '#f8f9fa',
                                                        zIndex: 8
                                                    }}
                                                    className="px-1 py-2 font-weight-bold"
                                                >
                                                    <div style={{ fontSize: '12px' }}>{dMoment.format('DD')}</div>
                                                    <div style={{ fontSize: '10px', color: isWeekend ? '#d39e00' : '#6c757d' }}>{dayOfWeek}</div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {isMatrixLoading ? (
                                        <tr>
                                            <td colSpan={matrixDates.length + 2} className="py-4 text-center text-muted">
                                                <span className="spinner-border spinner-border-sm text-primary mr-2" role="status"></span>
                                                Đang tải thời khóa biểu...
                                            </td>
                                        </tr>
                                    ) : matrixRows.length === 0 ? (
                                        <tr>
                                            <td colSpan={matrixDates.length + 2} className="py-5 text-center text-muted">
                                                <i className="fas fa-calendar-times fa-2x mb-2 d-block text-secondary"></i>
                                                Chưa có dữ liệu thời khóa biểu của bạn trong tháng {thang}/{nam}.
                                            </td>
                                        </tr>
                                    ) : (
                                        matrixRows.map((row, rIdx) => {
                                            const rowTitle = row.hocVienTen || 'Thời khóa biểu';
                                            return (
                                                <tr key={rIdx}>
                                                    <td style={{ position: 'sticky', left: 0, background: '#fff', zIndex: 5 }}>{rIdx + 1}</td>
                                                    <td style={{ position: 'sticky', left: 45, background: '#fff', zIndex: 5 }} className="text-left font-weight-bold">
                                                        <i className="fas fa-book-reader text-info mr-2"></i>
                                                        {rowTitle}
                                                        {row.donVi && <span className="small text-muted d-block font-weight-normal">{row.donVi}</span>}
                                                    </td>
                                                    {matrixDates.map((dStr, dIdx) => {
                                                        const cell = row.scheduleByDate ? row.scheduleByDate[dStr] : null;
                                                        let isNghi = false;
                                                        let isHoc = false;
                                                        let maKhoa = '';
                                                        let fullDonVi = '';
                                                        let gvTen = '';
                                                        let ghiChu = '';

                                                        if (cell) {
                                                            if (typeof cell === 'string') {
                                                                if (cell === 'Nghỉ') isNghi = true;
                                                                else if (cell !== '-') {
                                                                    isHoc = true;
                                                                    maKhoa = cell;
                                                                    fullDonVi = cell;
                                                                }
                                                            } else {
                                                                if (cell.trangThai === 'Nghi') isNghi = true;
                                                                else if (cell.trangThai === 'Hoc' || cell.maDonVi || cell.donVi || cell.giangVienTen) {
                                                                    isHoc = true;
                                                                    maKhoa = cell.maDonVi || cell.donVi || 'Học';
                                                                    fullDonVi = cell.donVi || cell.maDonVi || '';
                                                                    gvTen = cell.giangVienTen || '';
                                                                    ghiChu = cell.ghiChu || '';
                                                                }
                                                            }
                                                        }

                                                        let cellBg = "#fff";
                                                        if (isNghi) cellBg = "#f8d7da";
                                                        else if (isHoc) cellBg = "#e3f2fd";

                                                        if (isNghi) {
                                                            return (
                                                                <td key={dIdx} style={{ backgroundColor: cellBg, padding: '6px 2px', verticalAlign: 'middle' }}>
                                                                    <span className="badge badge-danger font-weight-normal" style={{ fontSize: '10px' }}>Nghỉ</span>
                                                                </td>
                                                            );
                                                        }

                                                        if (isHoc) {
                                                            const popover = (
                                                                <Popover id={`popover-hv-${rIdx}-${dIdx}`}>
                                                                    <Popover.Title as="h3" style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                                        Buổi học: {moment(dStr).format('DD/MM/YYYY')}
                                                                    </Popover.Title>
                                                                    <Popover.Content style={{ fontSize: '12px' }}>
                                                                        <div><strong>Khoa / Bộ môn:</strong> {fullDonVi || "Chưa rõ"}</div>
                                                                        {gvTen && <div><strong>Giảng viên:</strong> {gvTen}</div>}
                                                                        {ghiChu && <div><strong>Ghi chú:</strong> {ghiChu}</div>}
                                                                    </Popover.Content>
                                                                </Popover>
                                                            );

                                                            return (
                                                                <OverlayTrigger key={dIdx} trigger={['hover', 'focus']} placement="auto" overlay={popover}>
                                                                    <td style={{ backgroundColor: cellBg, padding: '6px 2px', verticalAlign: 'middle', cursor: 'pointer' }}>
                                                                        <span className="font-weight-bold text-primary" style={{ fontSize: '11px' }}>
                                                                            {maKhoa || <i className="fas fa-check text-primary"></i>}
                                                                        </span>
                                                                    </td>
                                                                </OverlayTrigger>
                                                            );
                                                        }

                                                        return (
                                                            <td key={dIdx} style={{ backgroundColor: cellBg, padding: '6px 2px', verticalAlign: 'middle' }}>
                                                                <span className="text-muted" style={{ opacity: 0.35 }}>-</span>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            )}

            {/* VIEW 2: DANH SÁCH CÁC BUỔI HỌC */}
            {viewMode === 'list' && (
                <Card className="shadow-sm border-0">
                    <Card.Body className="p-0">
                        <div className="table-responsive">
                            <Table striped bordered hover className="mb-0 align-middle">
                                <thead className="thead-light">
                                    <tr>
                                        <th style={{ width: 50 }} className="text-center">#</th>
                                        <th style={{ minWidth: 120 }} className="text-center">Ngày bắt đầu</th>
                                        <th style={{ minWidth: 120 }} className="text-center">Ngày kết thúc</th>
                                        <th style={{ minWidth: 150 }}>Khoa / Bộ môn</th>
                                        <th style={{ minWidth: 150 }}>Giảng viên phụ trách</th>
                                        <th style={{ minWidth: 120 }} className="text-center">Trạng thái</th>
                                        <th style={{ minWidth: 180 }}>Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isListLoading ? (
                                        <tr><td colSpan={7} className="text-center py-4">Đang tải danh sách buổi học...</td></tr>
                                    ) : listData.length === 0 ? (
                                        <tr><td colSpan={7} className="text-center py-4 text-muted">Chưa có lịch học nào.</td></tr>
                                    ) : (
                                        listData.map((item, idx) => (
                                            <tr key={item.id || idx}>
                                                <td className="text-center">{idx + 1}</td>
                                                <td className="text-center">{item.ngayBatDau ? moment(item.ngayBatDau).format('DD/MM/YYYY') : "—"}</td>
                                                <td className="text-center">{item.ngayKetThuc ? moment(item.ngayKetThuc).format('DD/MM/YYYY') : "—"}</td>
                                                <td>{item.donVi || "—"}</td>
                                                <td className="font-weight-bold">{item.giangVienTen || (item.giangViens && item.giangViens[0]?.giangVienTen) || "—"}</td>
                                                <td className="text-center">
                                                    {item.trangThai === 1 ? (
                                                        <Badge variant="danger">Nghỉ</Badge>
                                                    ) : (
                                                        <Badge variant="primary">Đi học</Badge>
                                                    )}
                                                </td>
                                                <td>{item.ghiChu || "—"}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default StudentScheduleThucHanhTab;
